export enum ServerIdentities {
  Secretary = 'Secretary',
  Moderator = 'Moderator',
  BreakoutLearning = 'Breakout Learning',
}

export const ServerIdentitiesList: ServerIdentities[] = [
  ServerIdentities.Secretary,
  ServerIdentities.Moderator,
  ServerIdentities.BreakoutLearning,
]
